<template>
	<div class="d-inline-block mr-1 mb-2 pb-1 pr-2 badge" :data-badge="value">
        <slot></slot> 
    </div>
</template>
<script>
	export default {
		props: ["value"]
	}
</script>